import InvestorInvestmentLayout from "./InvestorInvestmentLayout"

export default InvestorInvestmentLayout
